import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  private calls = 0;

  constructor(private router: Router, private spinner: NgxSpinnerService) { }

  private redirectToLogin(err:any) {
    if (err.status === 403) {
        //this.redirectionStatus = 3;
        return Observable.throw(err);
    } else if (err.status !== 500 && err.status !== 400 && err.status !== 404 && err.status !== 417 ) {
//        this.redirectionStatus = 2;
        localStorage.clear();
        sessionStorage.clear();
        //this.router.navigate(["../login"], { relativeTo: this.route});
        return Observable.throw(err);
    } else {
        err.message= err.statusText;
        return Observable.throw(err);
    }
}

  showSpinner(): void {
    this.calls++;
    this.spinner.show();
  }

  hideSpinner(): void {
    this.calls--;
    if (this.calls <= 0) {
      this.spinner.hide();
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser: any = JSON.parse(localStorage.getItem("currentUser"));

    request = request.clone({ headers: request.headers.set('Angular7', 'true') });

    if(request.url.indexOf('upload')<=0 ){
      if (currentUser && currentUser.Token) {
        request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + currentUser.Token) });
      }

      if (!request.headers.has('Content-Type')) {
        request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
      } 
      else if (request.headers.get('Content-Type') === 'multipart/form-data') {
        request = request.clone({ headers: request.headers.delete('Content-Type') });
      }
      
      if (!request.headers.has('Accept')) {
        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
      }
    }
    else{
      if (currentUser && currentUser.Token) {
        request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + currentUser.Token) });
      }
    }

     
   

//    console.log('intercepting...', request);

    this.showSpinner();
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
       //   console.log(`response`, event);

          if (event.body.isSessionExpired) {
            this.router.navigateByUrl(`/login`);
          }

          this.hideSpinner();

        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(`error`, error);

        this.hideSpinner();

        return this.redirectToLogin(error);
      }));
  }

}